import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";

// Re-export useAllJobsQuery from its new location for backwards compatibility
export { useAllJobsQuery } from "~/components/build/Show/lib/queries/allJobs";

/**
 * Get jobs from the build store.
 */
export function useJobs() {
  const { store } = useBuild();
  const jobs = useBuildStore((state) => state.jobs);

  return Features.ProgressiveBuildShow ? jobs : store.jobs;
}
